/* global module document window */

import React from 'react';
import has from 'lodash/has';
import get from 'lodash/get';
import pick from 'lodash/pick';
import { connect } from 'react-redux';
import cx from 'classnames';
import { bindActionCreators } from 'redux';
import Alerts from '../common/alerts/alerts.component';
import RestoreDefaultAnswers from './modals/restore_default_answers';
import Routes from './Routes';
import Toast from './Toast';
import { wrap, withT, withRouterAndHelpers } from '../../lib/wrappers';
import widgetListener from '../../lib/widgetListener';
import a from '../../redux/actions';
import selectors, { bindSelectors } from '../../redux/selectors';
import { routes, getLocaleFromWindowLocation, calculatorPages } from '../../lib/routerHelper';
import ResizableComponent from '../../lib/base_classes/ResizableComponent';

class LayoutComponent extends ResizableComponent {

  constructor(props, context) {
    super(props, context);
    const layout = this;
    layout.state = {
      prompt_restore_default_answers: false,
    };
  }

  get router() {
    return this.props.router;
  }

  componentWillReceiveProps(nextProps) {
    // passing false to setUserAnswersToDefault means no alerts will be triggered!
    if (this.props.currentRoute !== nextProps.currentRoute &&
      nextProps.ui.alert_exists) {
      this.props.resetAlerts();
    }
    const { updateNumericInput, token } = nextProps;
    if (token && !this.props.token) updateNumericInput({ input_changed: 1 });
  }

  componentDidMount() {
    this.receiveExternalOffset();
    const { initialize } = this.props;
    initialize();
  }

  get t() {
    return this.props.t;
  }

  get alert_list() {
    return get(this.props.ui, 'alerts.shared');
  }

  get alert_list_activation() {
    return get(this.props.ui, 'alerts.activation');
  }

  get is_no_app_route() {
    return this.props.currentRoute === routes.MISSING_ROUTE;
  }

  get external_offset() {
    return this.props.ui.external_offset;
  }

  get next_route_title() {
    return this.props.getRouteTitle(this.props.nextRoute);
  }

  get powered_by() {
    return get(this.props.ui, 'widget.options.powered_berkeley', false) ? 'CoolClimate.Berkeley.edu' : 'CoolClimate';
  }

  get terms_and_conditions_url() {
    const { ui } = this.props;
    if (get(ui, 'widget.source') === 'ontario') return '/assets/coolclimate-ontario-terms-of-use.pdf';
    return 'https://coolclimate.berkeley.edu/files2/CoolClimate-terms-of-use.pdf';
  }

  get bannerUrl() {
    let bannerUrl = get(this.props.ui, 'widget.options.banner_url', false);
    if (typeof bannerUrl === 'object') {
      const locale = getLocaleFromWindowLocation();
      bannerUrl = bannerUrl[locale] || bannerUrl.default;
    }
    return bannerUrl;
  }

  get iconBase() {
    return get(this.props.ui, 'widget.options.custom_icon_base', '/assets/img/');
  }

  toggleResetModal() {
    this.setState({
      prompt_restore_default_answers: !this.state.prompt_restore_default_answers,
    });
  }

  getRouteTitle(route) {
    return route.title(this.t);
  }

  receiveExternalOffset() {
    widgetListener.create((data) => {
      // TODO: We should move all of this to props.receiveWidgetMessage.
      if (has(data, 'cta')) {
        this.props.updateUI({ id: 'external_offset', data });
        if (has(data, 'connect_to_api')) {
          if (!get(this.props.ui, 'external_offset.connect_to_api')) {
            this.props.updateUI({ id: 'connect_to_api', data: false });
          }
        }
      }
      if (has(data, 'source')) {
        this.props.updateUI({ id: 'source', data: data.source });
      }

      this.props.receiveWidgetMessage(data);
    });
    const message = {
      type: 'onInit',
    };
    let sentInit = false;
    window.iFrameResizer = {
      readyCallback: () => {
        window.parentIFrame.sendMessage(JSON.stringify(message));
        sentInit = true;
      },
    };
    if (window.parentIFrame && !sentInit) {
      window.parentIFrame.sendMessage(JSON.stringify(message));
    }
  }

  destroyPrerenderData() {
    const prerender_data = document.getElementById('prerender_data');
    window.PrerenderData = undefined;
    if (prerender_data) prerender_data.parentNode.removeChild(prerender_data);
  }

  render() {
    return (
      <div>
        <link rel="stylesheet" type="text/css" href={get(this.props.ui, 'widget.options.custom_style', {})} />
        {(!this.props.isFootprintInitialized || this.props.spinner) &&
          <div
            id="layout__overlay"
          >
            <div id="layout__overlay__bg" />
            <div id="layout__overlay__spinner" />
          </div>
        }
        {this.props.isFootprintInitialized &&
          <div id="cc_calculator_ui">
            <nav className="navbar navbar-default">
              <div id="cc_nav" className={cx({ 'cc-nav__no-settings': !this.connect_to_api })}>
                {calculatorPages.map(route => (
                  <div
                    key={route}
                    className={cx('cc-nav__item', { 'cc-nav__item--active': this.props.currentRoute === route })}
                    onClick={() => this.props.currentRoute !== route &&
                      this.props.goToRouteByName(route)}
                  >
                    {(route !== this.props.currentRoute) &&
                      <img
                        src={`${this.iconBase}${route}-green.svg`}
                        alt={this.props.getRouteTitle(route)}
                      />
                    }
                    {(route === this.props.currentRoute) &&
                      <img
                        src={`${this.iconBase}${route}-filled.svg`}
                        alt={this.props.getRouteTitle(route)}
                      />
                    }
                    <div>{this.props.getRouteTitle(route)}</div>
                  </div>
                ))}
              </div>
            </nav>
            {this.bannerUrl &&
              <div id="external_banner">
                <img
                  src={this.bannerUrl}
                  style={get(this.props.ui, 'widget.options.banner_style', {})}
                  alt={'Banner'}
                />
              </div>
            }
            <Alerts list={this.alert_list_activation} confirmAccount={this.props.confirmAccount} />
            <Alerts list={this.alert_list} />

            <Routes />

            {get(this.props.ui, 'toast.on', false) && <Toast />}

            <div className="terms-footer">
              <div className="content">
                <ul>
                  <li className="with-seperator"><a href="http://coolclimate.berkeley.edu/" target="_parent">{this.t('powered by')} {this.powered_by}</a></li>
                  <li className="with-seperator"><a href={this.terms_and_conditions_url} target="_parent">{this.t('terms of use')}</a></li>
                  {this.props.widgetSource === '!ontario' &&
                    <li className="with-seperator"><a href="/assets/ontario-faq.pdf" target="_parent">{this.t('FAQ')}</a></li>
                  }
                  <li><a href="http://pubs.acs.org/doi/suppl/10.1021/es4034364" target="_parent">{this.t('documentation')}</a></li>
                </ul>
              </div>
            </div>
            <RestoreDefaultAnswers
              show={this.state.prompt_restore_default_answers}
              close={() => this.setState({ prompt_restore_default_answers: false })}
              restoreDefaults={
                () => this.setState({
                  prompt_restore_default_answers: false,
                }, () => this.setUserAnswersToDefault(false))
              }
              is_user_logged_in={this.props.isTokenValid}
            />
          </div>
        }
      </div>
    );
  }

}

const mapStateToProps = (state, ownProps) => bindSelectors(
  pick(selectors, [
    'isFootprintInitialized', 'token', 'widgetSource', 'location',
    'average_footprint', 'ui', 'isTokenValid', 'widgetSource',
    'spinner',
  ]), state, ownProps,
);

const mapDispatchToProps = dispatch => bindActionCreators(
  pick(a, [
    'initialize',
    'updateNumericInput',
    'receiveWidgetMessage',
    'updateUI',
  ]),
  dispatch,
);

export default wrap(
  withT('common'),
  withRouterAndHelpers,
  connect(mapStateToProps, mapDispatchToProps),
  LayoutComponent,
);
